import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { InfoSpedizioniVini } from 'src/app/_classi/InfoSpedizioniVini';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';
import { VinoItem } from 'src/app/_classi/VinoItem';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CantinaService } from 'src/app/_servizi/cantina.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

function TRANSLATE(str: string) {
  return str;
}
@Component({
  selector: 'app-vini-base',
  templateUrl: './vini-base.component.html',
  styleUrls: ['./vini-base.component.css']
})
export class ViniBaseComponent implements OnInit, OnChanges {

  get isMobile() {
    return this.appoggioService.getFromMobile();
  }

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  @Input() codiceForm: any;
  @Input() linguaCorrente: string;
  @Input() vini: VinoItem[];
  @Input() pacchetti: PacchettoItem[];

  @Output() filtraPacchetti = new EventEmitter<any>();
  @Output() selezionaVino = new EventEmitter<any>();


  vinoSelezionato: VinoItem = null;
  viniArray: VinoItem[] = [];
  viniFiltered: VinoItem[] = [];

  filtroProdotto = null;
  prodotti = [
    { id: '0', label_traduzione: TRANSLATE('base.tutti'), label: 'Tutti', visible: true },
    { id: '6', label_traduzione: TRANSLATE('base.winebox'), label: 'WineBox', visible: true },
    { id: '1', label_traduzione: TRANSLATE('base.rosso'), label: 'Rosso', visible: true },
    { id: '2', label_traduzione: TRANSLATE('base.bianco'), label: 'Bianco', visible: true },
    { id: '3', label_traduzione: TRANSLATE('base.rosato'), label: 'Rosato', visible: true },
    { id: '4', label_traduzione: TRANSLATE('base.spumante'), label: 'Spumante', visible: true },
    { id: '5', label_traduzione: TRANSLATE('base.altri'), label: 'Altri prodotti', visible: true },
  ];
  prodottiVisibili = [];

  infoSpedizioni: InfoSpedizioniVini;

  constructor(
    private messageService: MessageServiceService,
    private cantinaService: CantinaService,
    private host: ElementRef,
    private zone: NgZone,
    private appoggioService: AppoggioService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.viniFiltered = this.vini;
    let i = 0;
    for (const prodotto of this.prodotti) {
      if (i != 0) {
        if (prodotto.label !== 'WineBox') {
          prodotto.visible = this.vini.filter(
            vino => vino.colore_id && vino.colore_id === prodotto.id
          ).length > 0 ? true : false;
        }
      }
      i++;
    }
    this.prodottiVisibili = this.prodotti.filter(prodotto => prodotto.visible);
    this.infoSpedizioni = this.cantinaService.getInfoSpedizioniSconti();
  }

  ngOnInit(): void {
    this.filtroProdotto = this.prodottiVisibili[0].label;
  }

  apriDettaglioVino(event, idx, vino) {
    if (event) {
      event.preventDefault();
    }
    this.cantinaService.setIdxViSelezionato(null);
    this.viniArray = [];
    this.vinoSelezionato = vino;
    this.viniArray.push(this.vinoSelezionato);
    this.cantinaService.setIdxViSelezionato(idx);
    this.selezionaVino.emit(true);
  }

  tornaIndietro() {
    this.cantinaService.setIdxViSelezionato(null);
    this.vinoSelezionato = null;
    this.viniArray = [];
    this.selezionaVino.emit(false);
  }

  filtra(filtro) {
    switch (filtro) {
      case 'Tutti':
        this.viniFiltered = this.vini;
        break;
      case 'WineBox':
        this.viniFiltered = [];
        break;
      default:
        this.viniFiltered = this.vini.filter(vino => vino.colore_id === filtro || filtro === '0');
    }
    this.filtraPacchetti.emit(filtro);
  }

  percentualeSconto(vino: VinoItem) {
    const first = vino.prezzo;
    const last = vino.choosePrezzoScontato(vino);
    return last * 100 / first - 100;
  }
}
